
define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");

    var ConnectorUpdateFieldModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ConnectorUpdateFieldModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.SourceConnectorsUpdateField,
            name: "ConnectorUpdateFieldModel",
            defaults: {
                name: "",
                value: "",
                type: ""
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ConnectorUpdateFieldModel;
});

